import {convertObjectToQuery} from "@js/globalFunctions/convertObjectToQuery";

export default function (parameters,prPage,page,order,fetchAll){
    prPage = typeof prPage ? 10 : prPage;
    page = typeof page === 'undefined' ? 1 : page;
    order = typeof order === 'undefined' ? 'default' : order;
    fetchAll = typeof fetchAll === 'undefined' ? false : fetchAll;

    let parsed = {};
    Object.keys(parameters).forEach(key => {
        if(Array.isArray(parameters[key]))
        {
            parsed[key] = {
                v: parameters[key][0],
                c: typeof parameters[key][1] !== 'undefined' ? parameters[key][1] : 'default'
            }
        }
        else
        {
            parsed[key] = parameters[key];
        }
    });

    let request = {
        p: parsed,
        pr: prPage,
        page: page,
        order: order
    };
    if(fetchAll)
    {
        request.page = 1;
        request.pr = prPage*page;
    }
    return themeUrl+'/includes/performSearchV3.php?'+convertObjectToQuery(request);
}
